export default __webpack_public_path__ + "static/media/card-b.8eb37e82.svg";